// extracted by mini-css-extract-plugin
module.exports = {"cls1":"layout-Footer-module--cls1--11j5v","cls2":"layout-Footer-module--cls2--sH0v9 layout-Footer-module--cls1--11j5v"};